import type { ExperimentPipeline, PipelineStage } from 'types';

/**
 * The words the editor uses for the enum values.
 *
 * Kept out of the components so the board, the column and the index card cannot drift
 * into describing the same advance rule two different ways.
 */
export const ADVANCE_RULE_LABELS: Record<PipelineStage['advanceRule'], string> = {
  'all-concluded': 'When every experiment has stopped',
  'any-significant': 'When the first result is conclusive',
  manual: 'When a person decides',
};

export const ADVANCE_RULE_HINTS: Record<PipelineStage['advanceRule'], string> = {
  'all-concluded': 'Nothing is cut short. The slowest experiment sets the pace.',
  'any-significant': 'Faster, at the cost of abandoning the others mid-flight.',
  manual: 'For a stage whose next step depends on what the result was.',
};

/**
 * Border + text for the state pills, in console tokens only.
 *
 * `running` is the one state the board draws attention to, so it takes `ok`; `complete`
 * is finished rather than good and takes `accent`; anything inert stays on `dim` so a
 * board of pending stages reads as one quiet column of chips rather than five colours.
 */
export const STAGE_STATE_TONES: Record<PipelineStage['state'], string> = {
  pending: 'border-line text-dim',
  running: 'border-ok-line text-ok',
  complete: 'border-accent-line text-accent',
  skipped: 'border-line text-dim line-through',
};

export const PIPELINE_STATUS_TONES: Record<ExperimentPipeline['status'], string> = {
  Draft: 'border-line text-dim',
  Running: 'border-ok-line text-ok',
  Paused: 'border-warn-line text-warn',
  Complete: 'border-accent-line text-accent',
  Cancelled: 'border-line text-dim line-through',
};
